'use client';

import React, { useState, useEffect } from 'react';
import styles from './ChooseBrand.module.scss';

const ChooseBrand = ({ onBrandSelect, sitecoreData }) => {
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [hoveredBrand, setHoveredBrand] = useState(null);
  const [autoSelected, setAutoSelected] = useState(false);

  // �?Sitecore 数据中获取品牌信�?
  const brands =
    sitecoreData?.carType?.map((brand) => ({
      id: brand.name,
      name: brand.displayName,
      titleImage: brand.fields.titleImage?.fields || {},
      carImage: brand.fields.carImage?.fields || {},
      buttonText: brand.fields.buttonText?.value || 'Configure',
      carModel: brand.fields.carModel || [],
    })) || [];

  // 检测URL参数并自动选择品牌
  useEffect(() => {
    if (autoSelected) return; // 防止重复执行

    const urlParams = new URLSearchParams(window.location.search);
    const carModel = urlParams.get('carModel');

    if (carModel && brands.length > 0) {
      // 查找匹配的品�?
      const matchedBrand = brands.find(
        (brand) => brand.id.toLowerCase() === carModel.toLowerCase()
      );

      if (matchedBrand) {
        setSelectedBrand(matchedBrand.id);
        setAutoSelected(true);

        // 延迟执行品牌选择，确保组件已完全渲染
        setTimeout(() => {
          if (onBrandSelect) {
            onBrandSelect(matchedBrand);
          }
        }, 0);
      }
    }
  }, [brands, onBrandSelect, autoSelected]);

  const handleBrandSelect = (brand) => {
    setSelectedBrand(brand.id);
    // 添加延迟以显示选择动画
    setTimeout(() => {
      if (onBrandSelect) {
        onBrandSelect(brand);
      }
    }, 300);
  };

  const handleBrandHover = (brandId) => {
    setHoveredBrand(brandId);
  };

  const handleBrandLeave = () => {
    setHoveredBrand(null);
  };

  // 获取响应式图�?URL
  const getResponsiveImageUrl = (imageField) => {
    if (!imageField) return '';

    // 根据屏幕尺寸选择合适的图片
    const isMobile = window.innerWidth <= 768;
    const isTablet = window.innerWidth <= 1024;

    if (isMobile && imageField.mobileImage?.value?.src) {
      return imageField.mobileImage.value.src;
    } else if (isTablet && imageField.tabletImage?.value?.src) {
      return imageField.tabletImage.value.src;
    } else if (imageField.desktopImage?.value?.src) {
      return imageField.desktopImage.value.src;
    }

    // 如果没有找到合适的图片，返回第一个可用的图片
    return (
      imageField.mobileImage?.value?.src ||
      imageField.tabletImage?.value?.src ||
      imageField.desktopImage?.value?.src ||
      ''
    );
  };

  return (
    <div className={styles.chooseBrandContainer}>
      <div className={styles.header}>
        <div
          className={styles.title}
          dangerouslySetInnerHTML={{
            __html: sitecoreData?.FirstTitle?.value || 'Choose brand and start configuring',
          }}
        />
      </div>

      <div className={styles.brandsGrid}>
        {brands.map((brand) => (
          <div
            key={brand.id}
            className={`${styles.brandCard} ${styles[brand.id]} ${
              selectedBrand === brand.id ? styles.selected : ''
            } ${hoveredBrand === brand.id ? styles.hovered : ''}`}
            onClick={() => handleBrandSelect(brand)}
            onMouseEnter={() => handleBrandHover(brand.id)}
            onMouseLeave={handleBrandLeave}
            style={{
              backgroundImage: `url(${getResponsiveImageUrl(brand.carImage)})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <img
              src={getResponsiveImageUrl(brand.titleImage)}
              alt={brand.name}
              className={styles.brandTitle}
            />
            {/* 背景遮罩�?*/}
            <div className={styles.backgroundOverlay}></div>
            <div className={styles.brandHeader}></div>
            <div className={styles.brandFooter}>
              <button className={styles.configureButton}>{brand.buttonText}</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChooseBrand;
